<template>
  <!-- 天气组件，显示天气信息 -->
  <div class="weather-container" v-if="weatherInfo.realtime">
    <slot :data="weatherInfo">
      <div class="main-info">
        <div class="title">{{weatherInfo.city}}</div>
        <div class="temperature">
          <div class="tm">
            <span class="number">{{weatherInfo.realtime.temperature}}</span>
            <span class="marker">°C</span>
          </div>
          <div class="info">{{weatherInfo.realtime.info}}</div>
        </div>
      </div>
      <div class="power">{{weatherInfo.realtime.direct}}&nbsp;&nbsp;&nbsp;{{weatherInfo.realtime.power}}</div>
    </slot>
  </div>
</template>

<script>

import commonApi from "@/api/commonApi";
import {watch} from "vue";

export default {
  props: {
    coordsNeed: {default: false}, // 是否需要提供坐标，默认不需要
    lng: {default: ""}, // 经纬度坐标
    lat: {default: ""},
  },
  name: "WeatherComponent",
  components: {
  },
  data() {
    return {
      weatherInfo: {}, // 查询天气结果
    };
  },
  created() {
    if (!this.coordsNeed) {
      // 不需要坐标
      this.getWeather();
    } else {
      this.getWeatherByLocation();
      watch(() => this.lng, () => {
        this.getWeatherByLocation();
      })
    }
  },
  methods: {
    // 不需要坐标加载天气
    getWeather() {
      commonApi.findWeather().then(res => {
        this.showWeather(res);
      })
    },
    // 需要坐标加载天气
    getWeatherByLocation() {
      if (!this.lat || !this.lng) {
        console.log("未加载坐标")
        return;
      }
      commonApi.findWeatherByLocation(this.lng, this.lat).then(res => {
        this.showWeather(res);
      })
    },
    showWeather(res) {
      this.weatherInfo = res.result;
      console.log(this.weatherInfo)
    }
  }
};
</script>

<style lang="scss" scoped>
.weather-container{
  .main-info{
    border-bottom: 1px solid var(--yq-border-color);
    .temperature{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tm{
        display: inline-flex;
        align-items: flex-start;
        .number{
          font-size: 34px;
        }
        .marker{
          margin-top: 5px;
        }
      }
      .info{

      }
    }
  }
  .power{
    color: #aaa;
  }
}
</style>